import React from "react";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./ContactUs.css";

// Step 1: Create array for multiple locations
const locations = [
  {
    title: "Office - Varanasi",
    address: `Blacksmith Industries Pvt. Ltd.
N 12/306 Shahid Bhagat Singh Marg
Lakharaon Bajardihan, Varanasi 221106, U.P. INDIA`,
    mapSrc: "https://www.google.com/maps?q=N+12%2F306+Shahid+Bhagat+Singh+Marg,+Lakharaon+Bajardihan,+Varanasi,+Uttar+Pradesh+221106,+India&output=embed"
  }
  ,
  {
    title: "Office - Jharsuguda",
    name: "S C Bosh",
    contact: "+91 81276 09605",
    address: `Reg. Number - 21AADCB8552GIZX,
    Ground Floor, A-1, Nand Vihar Colony,
Lamtibaha, Brajarajnagar,
Jharsuguda District, Odisha – 768216 INDIA`,
    mapSrc: "https://www.google.com/maps?q=Ground+Floor+A-1+Nand+Vihar+Colony+Lamtibaha+Brajarajnagar+Jharsuguda+Odisha+768216&output=embed"
  }
  ,
  {
    title: "Representative in Germany",
    name: "Punam Singh",
    contact: "+49 176 22216965",
    address: `Dietzgenstraße 80, 13156 Berlin, Germany`,
    mapSrc: "https://www.google.com/maps?q=Dietzgenstraße+80,+13156+Berlin,+Germany&output=embed"
  }
];

const ContactUs = () => {
  return (
    <div className="contact-page">
      <div className="facility-header">
        <h2><span className="highlight">Contact</span> Us</h2>
          <p className="product-intro">
        At Black Smith Industries, we're dedicated to supporting you every step of the way.
        Whether you’re inquiring about our products, seeking expert assistance. We value your time and are
        committed to delivering prompt, reliable, and personalized support. we’re always ready to help.
      </p>

      </div>
    
      <div className="contact-info">
        <div className="info-card">
          <h3>Business Name</h3>
          <p>BLACKSMITH INDUSTRIES PVT. LTD.</p>
        </div>

        <div className="info-card">
          <h3><FaEnvelope /> Mail Us</h3>
          <p>
            <a href="mailto:info@blacksmithindustries.com" style={{ color: 'inherit', textDecoration: 'none' }}>
              info@blacksmithindustries.com
            </a>
          </p>
        </div>

        <div className="info-card">
          <h3><FaPhoneAlt /> Contact</h3>
          <p>
            <FaWhatsapp />{' '}
            <a href="https://wa.me/919026360813" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
              +91 9026360813
            </a>
          </p>
          <p>
            <FaPhoneAlt />{' '}
            <a href="tel:+919026360813" style={{ color: 'inherit', textDecoration: 'none' }}>
              +91 542-4068748
            </a>
          </p>
        </div>
      </div>

      {/* Step 2: Loop through each location to display address and map */}
      <div className="contact-locations">
        <h2><span className="highlight">Our</span> Locations</h2>
        <div className="high">
          {locations.map((location, index) => (
            <div key={index} className="location-block">
              <div className="location-columns">
                <div className="address-column">
                  <h3><FaMapMarkerAlt /> {location.title}</h3>

                  {/* Show owner if present */}
                  {location.name && (
                    <p><strong>Name:</strong> {location.name}</p>
                  )}

                  {/* Show contact if present */}
                  {location.contact && (
                    <p><strong>Contact:</strong> <a href={`tel:${location.contact}`}>{location.contact}</a></p>
                  )}

                  <p style={{ whiteSpace: 'pre-line' }}>{location.address}</p>
                </div>


                <div className="map-column">
                  <iframe
                    src={location.mapSrc}
                    title={`Map-${index}`}
                    width="100%"
                    height="300"
                    style={{ borderRadius: "10px", border: 0 }}
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>





    </div>
  );
};

export default ContactUs;
